module.exports = __webpack_public_path__ + "img/2.080d3deb.jpg";